module.exports = __webpack_public_path__ + "img/selected3-min.cdfc505a.png";